import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { TodoModel, RecurrenceFrequency } from '../models/todo.model';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TodoService {
  private apiUrl = environment.APP_BASE_URL + '/staff-view/todo/';

  constructor(private http: HttpClient) {}

  getStaffTodos(date: string) {
    return this.http.get<TodoModel[]>(`${this.apiUrl}all?date=${date}`);
  }

  getUpcomingTodos() {
    return this.http.get<TodoModel[]>(`${this.apiUrl}upcoming`);
  }

  createTodo(todo: TodoModel) {
    return this.http.post<TodoModel>(`${this.apiUrl}create`, todo);
  }

  /**
   * Creates a recurring todo with automatic generation of future instances
   */
  createRecurringTodo(todo: TodoModel) {
    return this.http.post<TodoModel>(`${this.apiUrl}create-recurring`, todo);
  }

  completeTodo(todoId: string) {
    return this.http.put<boolean>(`${this.apiUrl}${todoId}/complete`, {});
  }

  deleteTodo(todoId: string) {
    return this.http.delete<boolean>(`${this.apiUrl}${todoId}/delete`);
  }
}
